import { queryOptions } from '@tanstack/react-query';
import { getActualPromos, getPromoItems } from './freePassApi';

const FREE_PASS_KEY_ROOT = 'free-pass';

export const freePassQueries = {
  all: [FREE_PASS_KEY_ROOT] as const,
  promos: (userId: string) =>
    queryOptions({
      queryKey: [FREE_PASS_KEY_ROOT, 'promos', userId] as const,
      queryFn: getActualPromos,
      staleTime: 5 * 60 * 1000,
    }),
  items: ({ userId, promoId }: { userId: string; promoId: string }) =>
    queryOptions({
      queryKey: [FREE_PASS_KEY_ROOT, 'items', userId, promoId] as const,
      queryFn: () => getPromoItems(promoId),
      staleTime: 30 * 1000,
    }),
};
